<template>
  <div id="masonry-container" class="discovery-display-masonry" :class="size" ref="display">
    <masonry-item
      v-for="item in search.data.BibSearchRows"
      :key="item.position"
      :item="item"
      @imageLoaded="imageLoaded"
    />
  </div>
</template>

<script>
import MasonryItem from '@/components/displays/MasonryItem.vue';
import Masonry from 'masonry-layout';

export default {
  name: 'MasonryDisplay',
  components: {
    MasonryItem,
  },
  props: {
    search: Object,
  },
  data() {
    return {
      timeout: false,
    };
  },
  updated() {
  },
  mounted() {
    this.masonry = new Masonry(this.$refs.display, {
      itemSelector: '.discovery-item',
      percentPosition: true,
      horizontalOrder: true,
    });
  },
  unmounted() {
    this.masonry.destroy();
  },
  computed: {
    size() {
      let size = this.$root.params?.coverSize ?? 'medium';
      if (size === '') size = 'medium';
      return `cover-size-${size}`;
    },
  },
  methods: {
    imageLoaded() {
      if (this.timeout === false) {
        this.masonry.layout();
        this.timeout = true;
        setTimeout(() => {
          this.masonry.layout();
          this.timeout = false;
        }, 600);
      }
    },
  },
};
</script>

<style lang="less">
@import '~@/css/global';
.discovery-display-masonry {
  overflow: hidden;
  margin: 0 -4px;
}
.discovery-display-masonry .discovery-item {
  width: 100%;
  padding: 4px;
}
// Medium Cover Sizes
@media (min-width: 280px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 2); }
}
@media (min-width: 420px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 3); }
}
@media (min-width: 660px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 4); }
}
@media (min-width: 800px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 5); }
}
@media (min-width: 940px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 6); }
}
@media (min-width: 1080px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 7); }
}
@media (min-width: 1220px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 8); }
}
@media (min-width: 1360px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 9); }
}
@media (min-width: 1500px) {
  .discovery-display-masonry.cover-size-medium .discovery-item { width: calc(100% / 10); }
}

// Large Sizes
@media (min-width: 520px) {
  .discovery-display-masonry.cover-size-large .discovery-item { width: calc(100% / 2); }
}
@media (min-width: 780px) {
  .discovery-display-masonry.cover-size-large .discovery-item { width: calc(100% / 3); }
}
@media (min-width: 1040px) {
  .discovery-display-masonry.cover-size-large .discovery-item { width: calc(100% / 4); }
}
@media (min-width: 1300px) {
  .discovery-display-masonry.cover-size-large .discovery-item { width: calc(100% / 5); }
}
</style>
